/**
 * Date helpers for the event forms.
 *
 * The event time picker emits *local* datetime strings without a timezone
 * (`YYYY-MM-DDTHH:mm`). `new Date(...)` parses those in the browser's local
 * zone, which is what we want when comparing against "now".
 */

/** Start of the current local day — the earliest day an event may be scheduled. */
export function startOfToday(): Date {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

/**
 * True when `localDateTime` is already in the past. A 60s grace absorbs clock
 * skew and the seconds between picking a time slot and submitting the form, so
 * choosing the current time isn't rejected the instant the minute ticks over.
 */
export function isPastDateTime(localDateTime: string, now: number = Date.now()): boolean {
  if (!localDateTime) return false
  const t = new Date(localDateTime).getTime()
  if (Number.isNaN(t)) return false
  return t < now - 60_000
}
